export { NewsletterTabs, NewsletterHubEditorStep, NewsletterSentPreviewTabs, ResendType };
export type { NewsletterList, Newsletter, Template };

enum NewsletterTabs {
  sent = 1,
  scheduled,
  draft,
  archived,
}

enum ResendType {
  /**
   * This is when `resend` is `false`
   */
  NONE = 0,
  /**
   * OPCA
   */
  OPENED = 1,
  /**
   * NOCA
   */
  NOT_OPENED = 2,
}

enum NewsletterSentPreviewTabs {
  details = "details",
  preview = "preview",
  audience = "audience",
  links = "popularLinks",
  rejected = "localRejected",
}

interface Newsletter {
  engagementId: number;
  engagementTypeId: number;
  trackerId: number;
  status: "ACTIVE" | "TERMINATED" | "COMPLETED" | "SCHEDULED" | "CREATED";
  sendDate: Date;
  scheduledDate: Date;
  creationDate: Date;
  newsletterName: string | null;
  audienceType: string;
  audienceCount: number;
  audiencePercent: number;
  sentCount: number;
  opened: number;
  openedPercent: number;
  clicked: number;
  clickedPercent: number;
  ctorPercent: number;
  unsubscribed: number;
  unsubscribedPercent: number;
  revenue: number;
  orders: number;
  subject: string;
  isResend: boolean;
  sendSubscriptionTypeId: number;
  engagedTypeId: number;
  repeatRate: number | null;
  smartResend: boolean;
  smartEngageEnabled: boolean;
  editorTypeId: number;
  chargedSmsCredits?: number;
  hidden?: boolean;
}

type NewsletterList = Newsletter[];

export declare interface NewsletterHubResponse {
  newslettersTabs: NewsletterList;
  hasNextPage: boolean;
  totalPages: number;
  totalCount: number;
}

type Template = {
  categoryId: number;
  id: number;
  html: string;
  imageUrl: string;
  lang: string;
  title: string;
  unlayerConfig: string;
  type: "custom" | "edrone";
};

enum NewsletterHubEditorStep {
  template,
  design,
  settings,
  audience,
  schedule,
}
